import { Button, Modal } from "antd";
import { ReactNode } from "react";
import { FooterModal } from "../AppealForm.styled";
interface Props {
  children: ReactNode;
  visible: boolean;
  handleCancel: () => void;
  push: () => void;
}
const ModalNotification = ({
  children,
  visible,
  handleCancel,
  push,
}: Props) => {
  return (
    <>
      <Modal
        title="Уведомление"
        visible={visible}
        maskClosable={false}
        onCancel={handleCancel}
        centered
        closable={true}
        footer={[
          <FooterModal style={{ marginRight: "auto" }}>
            <Button
              type="primary"
              onClick={() => {
                push();
              }}
            >
              Перейти
            </Button>
          </FooterModal>,
        ]}
      >
        {children}
      </Modal>
    </>
  );
};

export default ModalNotification;
